import React from "react";
import style from "./home.module.scss";
import GitHubIcon from "@mui/icons-material/GitHub";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import pdf from "../../assets/cv/LeandroCV.pdf";
import { Animated } from "react-animated-css";
import { Link } from "react-scroll"

function HomeComponent({ items }) {
  const redirigir = items;
  return (
    <div className={style.container}>
      <div className={style.presentacion}>
        <div className={style.textoPresentacion}>
          <Animated
            animationIn="bounceInRight"
            isVisible={true}
            animationInDuration={2600}
          >
            <h2>HOLA, SOY</h2>
          </Animated>
          <Animated
            animationIn="bounceInDown"
            isVisible={true}
            animationInDuration={2900}
          >
            <h1>LEANDRO FEDERICO ANGEL</h1>
          </Animated>
          <Animated
            animationIn="bounceInRight"
            isVisible={true}
            animationInDuration={2600}
          >
            <h3>| FULL STACK DEVELOPER |</h3>
          </Animated>
        </div>
        <Animated
          className={style.animacion}
          animationIn="fadeIn"
          isVisible={true}
          animationInDelay={900}
          animationInDuration={2200}
        >
          <div className={style.botones}>
            <Link className={style.botonHome} to="aboutMe" spy={true} smooth={true} offset={50} duration={500}>MÁS SOBRE MÍ</Link>
            <a
              className={style.botonHome}
              href={pdf}
              target="_blank"
              rel="noopener noreferrer"
              // download="LeandroCV.pdf"
            >
              CV ACTUALIZADO
            </a>
          </div>
        </Animated>
        <Animated
          className={style.animacion}
          animationIn="bounce"
          isVisible={true}
          animationInDelay={900}
          animationInDuration={2300}
        >
          <div className={style.redes}>
            <button
              className={style.btnredes}
              onClick={() => {
                redirigir("mailto:federi.angel@gmail.com");
              }}
            >
              <AlternateEmailIcon sx={{ fontSize: 45 }} />
            </button>
            <button
              className={style.btnredes}
              onClick={() => {
                redirigir("https://www.linkedin.com/in/lf-angel/");
              }}
            >
              <LinkedInIcon sx={{ fontSize: 45 }} />
            </button>
            <button className={style.btnredes}>
              <GitHubIcon
                sx={{ fontSize: 45 }}
                onClick={() => {
                  redirigir("https://github.com/fede8932");
                }}
              />
            </button>
            <button className={style.btnredes}>
              <WhatsAppIcon
                sx={{ fontSize: 45 }}
                onClick={() => {
                  redirigir("https://wa.me/541123980816");
                }}
              />
            </button>
          </div>
        </Animated>
      </div>
    </div>
  );
}

export default HomeComponent;
